var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Suspense } from 'react';
import { observer } from 'mobx-react';
import { Box, Button, Flex, Icon, Text } from '@chakra-ui/react';
import { StoreContext } from '@/app/uistore/Rootstore';
import { MdClose } from '@react-icons/all-files/md/MdClose';
import { AppColor } from '@/app/const/AppDefaults';
import { ScaleLoader } from 'react-spinners';
import { DraftType } from '@@/Draft';
const AdminFloatingEditor = React.lazy(async () => await import("@/app/admin/UIComponents/AdminFloatingEditor"));
import { FiList } from '@react-icons/all-files/fi/FiList';
import { testIsMobile } from '@@/Util';
let AdminFloatingObjectViewer = class AdminFloatingObjectViewer extends React.Component {
    constructor() {
        super(...arguments);
        this.boxref = null;
        this.adjustx = 0;
        this.adjusty = 0;
        this.upcb = () => {
            const rstore = this.context;
            rstore.adminFloatingStore.setDragging(false);
        };
        this.mousemove = (e) => {
            const rstore = this.context;
            if (rstore.adminFloatingStore.dragging) {
                // lets move this dialog 
                rstore.adminFloatingStore.setTop(e.clientY - this.adjusty);
                rstore.adminFloatingStore.setLeft(e.clientX - this.adjustx);
            }
        };
    }
    componentDidMount() {
        window.addEventListener("mouseup", this.upcb);
        window.addEventListener("mousemove", this.mousemove);
    }
    componentWillUnmount() {
        window.removeEventListener("mouseup", this.upcb);
        window.removeEventListener("mousemove", this.mousemove);
    }
    render() {
        const rstore = this.context;
        if (!rstore.adminFloatingStore.show) {
            return React.createElement(React.Fragment, null);
        }
        return React.createElement(Box, { "object-viewer": 'colorbox', ref: (ref) => this.boxref = ref, bg: 'white', borderRadius: '4px', className: 'floating-dialog', zIndex: 5000, cursor: rstore.adminFloatingStore.dragging ? 'grabbing' : '', onMouseDown: (e) => {
                var _a, _b;
                const tgt = e.target;
                if (tgt.getAttribute("object-viewer")) {
                    rstore.adminFloatingStore.setDragging(true);
                    if (this.boxref) {
                        this.adjustx = e.clientX - ((_a = this.boxref) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().left);
                        this.adjusty = e.clientY - ((_b = this.boxref) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().top);
                    }
                }
            }, position: 'fixed', left: rstore.adminFloatingStore.left + "px", top: rstore.adminFloatingStore.top + "px", width: rstore.adminFloatingStore.width + "px", height: testIsMobile() ? (window.innerHeight - 150) + "px" : (window.innerHeight - 100) + "px" },
            React.createElement(Flex, { pos: 'relative', "border-bottom": '1px solid lightgray', padding: '10px', align: 'center', "object-viewer": 'colorbox', height: "50px", width: '100%' },
                React.createElement(Text, { overflow: 'hidden', textOverflow: 'ellipsis', title: rstore.adminFloatingStore.title, width: '60%', "object-viewer": 'colorbox', fontWeight: 'bold', fontSize: '12px', fontFamily: 'heading', color: AppColor.InputLabelColor }, rstore.adminFloatingStore.title),
                !rstore.floatingDraftViewStore.shownotespanel &&
                    React.createElement(Icon, { ml: '15px', _hover: { cursor: 'pointer' }, title: 'Show notes panel', onClick: () => rstore.floatingDraftViewStore.setShowNotesPanel(true), as: FiList }),
                React.createElement(Icon, { pos: 'absolute', right: '5px', ml: '20px', as: MdClose, color: AppColor.ResetFilter, h: '25px', w: '25px', _hover: { cursor: 'pointer' }, onClick: (e) => {
                        rstore.adminFloatingStore.setShow(false);
                        rstore.adminFloatingStore.reset();
                    }, className: 'message-option-button' })),
            rstore.floatingDraftViewStore.showdraftingview && rstore.floatingDraftViewStore.updating &&
                rstore.floatingDraftViewStore.drafttype === DraftType.XLSX
                && React.createElement(Flex, { "border-bottom": '1px solid lightgray', padding: '10px', "object-viewer": 'colorbox', height: "35px", width: '100%' },
                    React.createElement(Text, { width: '90%', "object-viewer": 'colorbox', fontWeight: 'bold', fontSize: '15px', fontFamily: 'heading' }, 'Rendering...')),
            rstore.adminFloatingStore.loading && React.createElement(Flex, { h: '100%', w: '100%', mt: '10px', justify: 'center', align: 'center' },
                React.createElement(ScaleLoader, { color: 'green' })),
            !rstore.adminFloatingStore.loading && React.createElement(Box, { h: '100%', w: '100%', mt: '10px' },
                React.createElement(Suspense, { fallback: React.createElement(Flex, { flexDirection: 'column', style: { height: '100%' }, justify: 'center', align: 'center' },
                        React.createElement(ScaleLoader, { color: 'green' }),
                        React.createElement(Text, { style: { fontWeight: 'bold', fontSize: '15px' } }, "Intialising Editor...")) },
                    React.createElement(AdminFloatingEditor, null))),
            React.createElement(Flex, { pos: 'relative', "border-bottom": '1px solid lightgray', padding: '10px', align: 'center', justify: 'flex-end', "object-viewer": 'colorbox', height: "30px", width: '100%' },
                React.createElement(Button, { w: '50px', variant: 'unstyled', onClick: () => {
                        rstore.adminFloatingStore.setShow(false);
                        rstore.adminFloatingStore.reset();
                    } }, "Close")));
    }
};
AdminFloatingObjectViewer.contextType = StoreContext;
AdminFloatingObjectViewer = __decorate([
    observer
], AdminFloatingObjectViewer);
export { AdminFloatingObjectViewer };
